import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a1120] py-12 border-t border-nova-navy-light/30" data-id="element-104">
      <div className="container mx-auto px-4 md:px-6" data-id="element-105">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-106">
          <div className="flex flex-col items-center md:items-start gap-4" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/hAaMCrG6LwNRmp8NJ3EKxP/heylloyd-image-1771645896523.png" alt="Nova Digital Ventures Logo" className="h-12 w-auto object-contain bg-white rounded p-1.5" data-id="element-108" />
            <p className="text-gray-400 text-sm text-center md:text-left max-w-xs" data-id="element-109">
              Especialistas en crecimiento digital para negocios locales en
              México.
            </p>
          </div>

          <div className="flex gap-6 text-sm text-gray-400" data-id="element-110">
            <a href="#" className="hover:text-nova-gold transition-colors" data-id="element-111">
              Términos
            </a>
            <a href="#" className="hover:text-nova-gold transition-colors" data-id="element-112">
              Privacidad
            </a>
            <a href="#contacto" className="hover:text-nova-gold transition-colors" data-id="element-113">
              Contacto
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-nova-navy-light/20 text-center text-sm text-gray-500" data-id="element-114">
          &copy; {new Date().getFullYear()} Nova Digital Ventures. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}